import axios from "axios";

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/addonservices";

// GET
export async function getAddOnService(addOnServicePublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AddOnService/get-add-on-service/${addOnServicePublicId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Failed to fetch add on service by publicId");
  }
}

export async function getAddOnServicesByAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AddOnService/get-add-on-services-by-agreement/${agreementPublicId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Failed to fetch add-on-service by agreement");
  }
}

// PUT
export async function updateBillingGroupOnAddOnService(
addOnServiceUpdateData,
  apiAccessToken
) {
  try {
    const requestData = {
      billingGroupPublicId: addOnServiceUpdateData.billingGroupPublicId,
      addOnServicePublicId: addOnServiceUpdateData.addOnServicePublicId,
      updatedDateTimeUTC: new Date().toISOString(),
    };

    const response = await axios.put(
      `${baseUrl}/AddOnService/update-billing-group-on-add-on-service`,
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API Error Response:", error.response?.data);
    throw new Error(error.response?.data?.message || "Failed to update billing group on add on service"
    );
  }
}

